export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELS1NDbXMtVUhDLUhhEKGiAb54AQC+egAAwQACAr57AQC+fgQLvn8tAL8LgzUAvwwGAb8NAgC/DwEAvxALBb8RGwC/FwEAvxgBAL8ZGwO/Gg==", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/KSCms-UHC-V.bcmap
// module id = TqcY
// module chunks = 0